// extracted by mini-css-extract-plugin
export default {"preferredRooms":"styles_preferredRooms__OOTcj"};